/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TileSettlement } from './TileSettlement';
export type TileLocation = {
    settlement?: TileSettlement | null;
    latitude?: number | null;
    longitude?: number | null;
    address?: string;
    streetNumber?: string;
    postalCode?: string;
    currency?: TileLocation.currency;
    isNocClone?: boolean;
};
export namespace TileLocation {
    export enum currency {
        UNKNOWN = 'Unknown',
        HUF = 'HUF',
        EUR = 'EUR',
        GBP = 'GBP',
        RON = 'RON',
        PLN = 'PLN',
        USD = 'USD',
        CZK = 'CZK',
    }
}
